import { ImageWithFallback, Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const TrackingEventsContainer = styled.div(({ theme }) => ({
  padding: `${theme.spacing[16]} 0px ${theme.spacing[8]} 0px`,
}));

export const EventGroup = styled.div`
  :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[16]};
  }

  ${({ theme }) => theme.mediaBreakpointUp.lg} {
    :not(:last-child) {
      margin-bottom: ${({ theme }) => theme.spacing[12]};
    }
  }
`;

export const EventDate = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})`
  ${({ theme }) => `
    color: ${theme.colors.mediumEmphasisBlack};
    margin-bottom: ${theme.spacing[12]};
  `}
`;

export const DetailsWrapper = styled.div`
  ${({ theme }) => `
    margin-left: ${theme.spacing[4]};
    border-left: 4px solid ${theme.colors.mediumEmphasisBlack};
    padding: ${theme.spacing[8]} 0 ${theme.spacing[8]} ${theme.spacing[20]};
  `}

  display: flex;
  position: relative;
`;

const CIRCLE_ICON_SIZE = 12;

export const CircleIcon = styled.div`
  width: ${CIRCLE_ICON_SIZE}px;
  height: ${CIRCLE_ICON_SIZE}px;
  border-radius: 50%;
  border: 2px solid black;
  background: white;
  position: absolute;
  top: 13px;
  left: -8px;
`;

export const Details = styled.div`
  flex-grow: 1;
  word-break: break-word;
`;

export const EventTime = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})`
  ${({ theme }) => `
    color: ${theme.colors.highEmphasisBlack};
    margin-bottom: ${theme.spacing[4]};
  `}
`;

export const Name = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  display: flex;
  align-items: flex-start;
`;

export const Location = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})`
  ${({ theme }) => `
    color: ${theme.colors.mediumEmphasisBlack};
    margin-top: ${theme.spacing[4]};
  `}
`;

const ISSUE_ICON_SIZE = 17;

export const IssueIcon = styled.img.attrs({
  src: '/images/issue-icon.svg',
  alt: 'issue icon',
})`
  width: ${ISSUE_ICON_SIZE}px;
  height: ${ISSUE_ICON_SIZE}px;
  margin-left: ${({ theme }) => theme.spacing[10]};
  vertical-align: middle;
`;

const CARRIER_LOGO_SIZE = 40;
const CARRIER_LOGO_SIZE_DESKTOP = 56;

export const CarrierLogo = styled(ImageWithFallback)`
  border-radius: 2px;
  cursor: pointer;
  width: ${CARRIER_LOGO_SIZE}px;
  min-width: ${CARRIER_LOGO_SIZE}px;
  height: ${CARRIER_LOGO_SIZE}px;

  ${({ theme }) => `
    border: 1px solid ${theme.colors.surface05};
    margin-left: ${theme.spacing[16]};
    margin-top: ${theme.spacing[26]};

    ${theme.mediaBreakpointUp.lg} {
      width: ${CARRIER_LOGO_SIZE_DESKTOP}px;
      min-width: ${CARRIER_LOGO_SIZE_DESKTOP}px;
      height: ${CARRIER_LOGO_SIZE_DESKTOP}px;
    }
  `}
`;
